var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#262626"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5195 12H13.4766C12.6602 12 12 12.6445 12 13.4414V30.5547C12 31.3516 12.6602 32 13.4766 32H30.5195C31.3359 32 32 31.3516 32 30.5586V13.4414C32 12.6445 31.3359 12 30.5195 12ZM17.9336 29.043H14.9648V19.4961H17.9336V29.043ZM16.4492 18.1953C15.4961 18.1953 14.7266 17.4258 14.7266 16.4766C14.7266 15.5273 15.4961 14.7578 16.4492 14.7578C17.3984 14.7578 18.168 15.5273 18.168 16.4766C18.168 17.4219 17.3984 18.1953 16.4492 18.1953ZM29.043 29.043H26.0781V24.4023C26.0781 23.2969 26.0586 21.8711 24.5352 21.8711C22.9922 21.8711 22.7578 23.0781 22.7578 24.3242V29.043H19.7969V19.4961H22.6406V20.8008H22.6797C23.0742 20.0508 24.043 19.2578 25.4844 19.2578C28.4883 19.2578 29.043 21.2344 29.043 23.8047V29.043Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLn);
export default __webpack_public_path__ + "static/media/ln.2f6e29a79b7de774eedd700ecb20f30b.svg";
export { ForwardRef as ReactComponent };